import { lazy } from 'react'
const Product = lazy(() => import('./product/Product'))
const Products = lazy(() => import('./products/Products'))
const ReviewGatewayConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'review_gateways_settings',
      element: <Products />,
      children: [
        {
          path: ':id',
          element: <Product />,
        },
       
      ],
    },
  ],
}

export default ReviewGatewayConfig
